import { Box, Button, Grid, Typography } from "@mui/material";
import Sidebar from "../../sidebar/sidebar";
import CustomerTable from "../CustomerTable";
import CustomerForm from "./CustomerForm";

function CreateCustomer() {
  return (
    <>
      {" "}
      <Box>
        <CustomerForm />
      </Box>
    </>
  );
}

export default CreateCustomer;
